import { StyleSheet } from "react-native"

const style = StyleSheet.create({
  pinView: {
    alignItems: "center",
  },
  buttonAreaContainer: {
    alignItems: "center",
    alignContent: "center",
    flexDirection: "row",
    flexWrap: "wrap",
  },
  buttonContainer: {
    marginBottom: 12,
    width: "33%",
    alignItems: "center",
    justifyContent: "center",
  },
  buttonView: {
    textAlign: "center",
    alignItems: "center",
    justifyContent: "center",
  },
  buttonText: {
    color: "#000",
    fontSize: 22,
    fontWeight: "bold",
  },
  inputContainer: {
    flexDirection: "row",
  },
  inputView: {
    margin: 6,
    backgroundColor: "#a3a7b9",
    textAlign: "center",
    alignItems: "center",
    justifyContent: "center",
  },
  inputText: {
    color: "#FFF",
    fontSize: 16,
    fontWeight: "bold",
  },
})
export default style
